import { useQuery } from "@tanstack/vue-query";

import { identityProvidersQueryKeys } from "~/queries/amplify/identityProviders";

export const useCustomProviders = () => {
  const { $amplify } = useNuxtApp();
  const { data } = useQuery({
    ...identityProvidersQueryKeys.providers(),
    staleTime: Infinity,
  });

  const results = computed(() => {
    return data.value?.results;
  });

  watchEffect(() => {
    $amplify?.setCustomProviders(
      results?.value?.map((provider) => ({
        custom: provider.cognitoProviderName,
      })) ?? [],
    );
  });

  return results;
};
